import React from 'react';
import { 
  FaStar, 
  FaQuoteLeft, 
  FaArrowRight,
  FaUserCircle,
  FaHeart
} from 'react-icons/fa';

const CustomerTestimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: "Akanksha Khanna",
      age: 27,
      content: "Delighted with my engagement ring! It's my dream ring, fits perfectly and is stunning to look at. Thanks for helping us find the perfect symbol of love!",
      rating: 5,
    },
    {
      id: 2,
      name: "Diksha Singh",
      age: 29,
      content: "I was worried about finding good quality fine jewellery pieces, but the customer service gave me full assurance and the delivery was super quick. Their jewellery is certified, and there is no compromise on quality.",
      rating: 5,
    },
    {
      id: 3,
      name: "Nutan Mishra",
      age: 33,
      content: "I got a Nazariya for my baby boy. It's so cute seeing it on my little one's wrist, and it gives me a sense of security knowing it's there. Thanks for making such lovely pieces for our little ones!",
      rating: 5,
    },
    {
      id: 4,
      name: "Divya Mishra",
      age: 26,
      content: "On Valentine's Day, my husband gifted me a necklace, and I haven't taken it off even once. Everyone asks me where it's from, and I just LOVE how nice it looks!",
      rating: 5,
    },
    {
      id: 5,
      name: "Priya Sharma",
      age: 31,
      content: "The craftsmanship is exceptional. I bought a pair of earrings for my sister's wedding and everyone was asking where they're from. Highly recommended!",
      rating: 5,
    }
  ];

  return (
    <div className="py-10 md:py-16 bg-gradient-to-br from-purple-50 via-pink-50 to-amber-50">
      <div className="container mx-auto px-4 max-w-7xl">
        
        {/* Header Section - No Brand Name */}
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
            Customer <span className="bg-gradient-to-r from-purple-600 via-pink-600 to-amber-600 bg-clip-text text-transparent">Testimonials</span>
          </h2>
          <div className="w-20 h-0.5 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full mb-3"></div>
          
          {/* Hashtag - No Brand Name */}
          <div className="inline-flex items-center gap-1 bg-white shadow-sm rounded-full px-4 py-1.5">
            <FaHeart className="w-3.5 h-3.5 text-pink-500" />
            <span className="text-sm font-semibold text-gray-700">#HappyCustomers</span>
          </div>
        </div>

        {/* Testimonials Grid - 5 cards in one row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="group bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 hover:border-purple-200 h-full flex flex-col"
            >
              <div className="p-4 flex-1 flex flex-col">
                {/* Quote Icon */}
                <div className="mb-3">
                  <FaQuoteLeft className="w-6 h-6 text-purple-300 opacity-50" />
                </div>
                
                {/* Testimonial Content */}
                <p className="text-gray-600 text-xs leading-relaxed mb-4 line-clamp-4 flex-1">
                  "{testimonial.content}"
                </p>
                
                {/* Divider */}
                <div className="h-px bg-gradient-to-r from-transparent via-purple-200 to-transparent my-3"></div>
                
                {/* Customer Info */}
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    {/* Avatar */}
                    <div className="w-8 h-8 rounded-full bg-gradient-to-r from-purple-100 to-pink-100 flex items-center justify-center">
                      <FaUserCircle className="w-6 h-6 text-purple-400" />
                    </div>
                    
                    {/* Name & Age */}
                    <div>
                      <h4 className="font-bold text-gray-800 text-xs">
                        {testimonial.name}
                      </h4>
                      <p className="text-gray-400 text-[10px]">
                        {testimonial.age} years
                      </p>
                    </div>
                  </div>
                  
                  {/* Rating Stars */}
                  <div className="flex items-center gap-0.5">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className="w-2.5 h-2.5 text-amber-400 fill-current" />
                    ))}
                  </div>
                </div>

                {/* View Button */}
                <button className="mt-3 w-full flex items-center justify-center gap-1.5 bg-gradient-to-r from-purple-50 to-pink-50 text-purple-600 py-1.5 rounded-lg text-[10px] font-medium hover:from-purple-600 hover:to-pink-600 hover:text-white transition-all duration-300 border border-purple-200 hover:border-transparent">
                  <span>View testimonial</span>
                  <FaArrowRight className="w-2.5 h-2.5" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-10">
          <button className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-600 via-pink-600 to-amber-600 text-white px-6 py-2.5 rounded-full font-semibold text-sm hover:shadow-lg hover:shadow-purple-200 transition-all duration-300 transform hover:scale-105">
            <span>View All Testimonials</span>
            <FaArrowRight className="w-3.5 h-3.5" />
          </button>
        </div>

      </div>

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .group {
          animation: fadeInUp 0.5s ease-out forwards;
          opacity: 0;
        }
        .group:nth-child(1) { animation-delay: 0.05s; }
        .group:nth-child(2) { animation-delay: 0.1s; }
        .group:nth-child(3) { animation-delay: 0.15s; }
        .group:nth-child(4) { animation-delay: 0.2s; }
        .group:nth-child(5) { animation-delay: 0.25s; }
        
        .line-clamp-4 {
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </div>
  );
};

export default CustomerTestimonials;